import React from 'react';

import { TEXTS } from '../texts';

/**
 * Before the label of a stage the claim was sent back to, the same on the stage bar and on the log's stages
 * rail. The arrow is for the eye; a screen reader hears "Back to" before the label instead.
 */
const ReturnMark: React.FC = () => (
  <>
    <span aria-hidden className="mr-4">
      ↩
    </span>
    <span className="sr-only">{`${TEXTS.BACK_TO} `}</span>
  </>
);

export default ReturnMark;
